import React                      from 'react'
import { Icon
       , Modal }                  from 'antd'


import { ERROR_CODE
       , TEXT
       , tr }                     from '../00_assets'
import { CTE
       , CodeError }              from '../01_core'

// export const ModalPrompt: React.FC<
//   { question: string
//   , show: boolean
//   , onOk: ( ) => any
//   , onCancel: ( ) => any
//   } > = ( props ) =>
// <Modal
//   title={ props.question }
//   visible={ props.show }
//   onOk={ props.onOk }
//   onCancel={ props.onCancel }
//   okText={ tr( TEXT.UI_BUTTON_OK ) }
//   cancelText={ tr( TEXT.UI_BUTTON_CANCEL ) }
// /> ;

export const ModalConfirm = ( on_ok: ( ) => any, opts: { title?: string, icon?: string } = { } ) =>
{
  const onOk = async ( ) =>
  {
    try
    {
      const ret = await on_ok( ) ;

      if ( ret && ret.error && ret.error.code !== ERROR_CODE.NONE )
           Modal.info( { title: ret.error.msg } )  ;
    }
    catch ( error )
    {
      Modal.info( { title: error.message } ) ;
    }
  } ;
 
  return Modal.confirm(
   { title: opts.title || tr( TEXT.ARE_YOU_SURE )
   , icon: <Icon type={ opts.icon || 'delete' } style={{ color: CTE.COLOR.FG }} />
   , okText: tr( TEXT.UI_BUTTON_OK )
   , cancelText: tr( TEXT.UI_BUTTON_CANCEL )
   , onOk
   } ) ;
}


const DONT_CLOSE = -4321 ;

export function avoid_closing_modal ( )
{
  throw new CodeError( DONT_CLOSE ) ;
}

 export const ModalPrompt = ( title: string
                            , content: React.ReactNode
                            , on_ok: ( ) => any
                            , icon: string = "edit"
                            , ok_text?: string ) =>
{
  const onOk = async ( ) =>
  {
    try
    {
      const ret = await on_ok( ) ;

      if ( ret && ret.error && ret.error.code !== ERROR_CODE.NONE )
           Modal.info( { title: ret.error.msg } )  ;
    }
    catch ( error )
    {
      if ( error.code !== DONT_CLOSE && error.message )
           Modal.info( { title: error.message } ) ;

      throw error ;
    }
  } ;
 
  return Modal.confirm(
  { title
  , content: <div className="mt-3">{ content }</div>
  , icon: <Icon type={ icon } style={{ color: CTE.COLOR.FG }} />
  , okText: ok_text || tr( TEXT.UI_BUTTON_SAVE )
  , cancelText: tr( TEXT.UI_BUTTON_CANCEL )
  , onOk
  } ) ;
 }